import { defineMessages } from 'react-intl';

import { SelectConfiguredOption } from '@app/hooks';
import { ItemStatus } from '@app/constants';
import { sharedMessages } from '@app/translations/sharedMessages';

const itemStatusPanelMessages = defineMessages({
  feeDue: {
    id: 'itemStatus.feeDue',
    defaultMessage: 'Fee due',
  },
  requested: {
    id: 'itemStatus.onRequest',
    defaultMessage: 'On request',
  },
  checkedOut: {
    id: 'itemStatus.checkedOut',
    defaultMessage: 'Checked out',
  },
  onLoan: {
    id: 'itemStatus.onLoan',
    defaultMessage: 'On loan',
  },
  overdue: {
    id: 'itemStatus.overDue',
    defaultMessage: 'Overdue',
  },
});

export const getItemStatusPanelMessages = (
  selectConfiguredOption: SelectConfiguredOption
) => ({
  feeDue: itemStatusPanelMessages.feeDue,
  [ItemStatus.onHold]: selectConfiguredOption(
    itemStatusPanelMessages.requested,
    sharedMessages.onHold
  ),
  [ItemStatus.checkedOut]: selectConfiguredOption(
    itemStatusPanelMessages.onLoan,
    itemStatusPanelMessages.checkedOut
  ),
  [ItemStatus.overdue]: itemStatusPanelMessages.overdue,
});

export const itemStatusPanelButtonMessages = defineMessages({
  renew: {
    id: 'itemStatus.renew',
    defaultMessage: 'Renew',
  },
  goToRequestsAndLoans: {
    id: 'itemStatus.goToRequestsAndLoans',
    defaultMessage: 'Go to requests & loans',
  },
  goToHoldsAndCheckouts: {
    id: 'itemStatus.goToHoldAndCheckouts',
    defaultMessage: 'Go to holds & checkouts',
  },
});
